define('gameInterfaces/pages/NetEntGameInterface',['netent'], function(netent) {

    function NetEntGameInterface(LOG, RealityCheckViewModel) {

        var self = this;

        function logErrorsWithFilter(prefix, e) {

            // Code 9 claims the functionality is not supported, but it works fine.
            // Seems to be on the first call to createDialogbox.
            if (e.code === 9) {
                return;
            }

            e.message = prefix + ': ' + e.message;

            LOG.error(e);

        }

        self.realityCheckViewModel = new RealityCheckViewModel(self);

        self.canActivate = function() {
            return self.realityCheckViewModel.canActivate();
        };

        self.compositionComplete = function() {

            netent.plugin.call('pluginReady', [], function() {});

            self.realityCheckViewModel.realityCheck.subscribe(function() {

                netent.plugin.call('stopAutoplay', [], function() {});

                displayFirstDialog();

            });

            netent.plugin.addEventListener(
                'dialogBoxClosed',
                function(boxId, buttonId) {

                    if (boxId === 'realitycheck' && buttonId === 'close') {

                        netent.plugin.call(
                            'removeDialogbox',
                            ['realitycheck'],
                            function() {
                                // Do nothing on success
                            },
                            logErrorsWithFilter.bind(null, 'removeDialogbox')
                        );

                        displaySecondDialog();
                    }

                }
            );

            function displayFirstDialog() {

                var fullMessage;

                fullMessage = self.realityCheckViewModel.message() + '\n\n';

                fullMessage += self.realityCheckViewModel.statusMessage();

                netent.plugin.call(
                    'createDialogbox',
                    [
                        'realitycheck',
                        self.realityCheckViewModel.title(),
                        fullMessage,
                        [
                            {
                                buttonid: 'continue',
                                buttontext: self.realityCheckViewModel.continueText()
                            },
                            {
                                buttonid: 'close',
                                buttontext: self.realityCheckViewModel.backToCasumoText()
                            }
                        ]
                    ],
                    function() {
                        // Do nothing on success
                    },
                    logErrorsWithFilter.bind(null, 'createDialogbox realitycheck')
                );

            }

            function displaySecondDialog() {

                netent.plugin.call(
                    'createDialogbox',
                    [
                        'backtocasumo',
                        self.realityCheckViewModel.backToCasumoTitle(),
                        self.realityCheckViewModel.backToCasumoMessage(),
                        [
                            {
                                buttonid: 'history',
                                action: 'gotolobby',
                                reason: 10,
                                buttontext: self.realityCheckViewModel.gameRoundHistoryText()
                            },
                            {
                                buttonid: 'lobby',
                                action: 'gotolobby',
                                reason: 11,
                                buttontext: self.realityCheckViewModel.exitGameText()
                            }
                        ]
                    ],
                    function() {
                        // Do nothing on success
                    },
                    logErrorsWithFilter.bind(null, 'createDialogbox backtocasumo')
                );

            }

        };
    }

    return NetEntGameInterface;

});

